import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { ResultDetail } from '../../../modules/result/@candidate';

const Result = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('exam->>ResultDetail.Results')} />
      <ResultDetail />
    </>
  );
};

export default Result;
